import { Flex, tokens, View, Avatar, Typography } from '@sapphire-react/core';
import { Error } from '@sapphire/icons/react';
import { useTranslation } from 'react-i18next';

type Props = { isHidden?: boolean };

const ErrorCard: React.FC<Props> = ({ isHidden = false }: Props) => {
  const { t } = useTranslation();

  return (
    <View
      height={216}
      backgroundColor={tokens.color.backgroundSurface.value}
      border={`1px solid ${tokens.color.borderFieldDefault.value}`}
      borderRadius={5}
      display={isHidden ? 'none' : 'block'}
    >
      <Flex
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        height={'100%'}
        role={'alert'}
        paddingLeft={48}
        paddingRight={48}
      >
        <View elementType={'div'} maxWidth={390} UNSAFE_style={{ textAlign: 'center' }}>
          <Avatar color={10} size={'lg'} icon={<Error />} />
          <Typography.Heading level={5} marginTop={tokens.size.spacingMd}>
            {t('results.error.heading')}
          </Typography.Heading>
          <Typography.Body marginTop={tokens.size.spacingSm} size={'sm'}>
            {t('results.error.subHeading')}
          </Typography.Body>
        </View>
      </Flex>
    </View>
  );
};

export default ErrorCard;
